import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacySliderModule as MatSliderModule } from '@angular/material/legacy-slider';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { RouterModule } from '@angular/router';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzTooltipModule } from '@blk/daisy/combinations/on-screen-help';
import { DzIconModule } from '@blk/daisy/core/icon';
import { DzProgressSpinnerModule } from '@blk/daisy/core/loading';
import { DzButtonModule } from '@blk/daisy/elements/buttons';
import { AccessibilityModule } from '@ddt-web/accessibility';
import { AnalyticsModule } from '@ddt-web/analytics';
import { DomModule } from '@ddt-web/dom';
import { GenericDirectivesModule, GenericPipesModule } from '@ddt-web/generic-utils';
import { faChartPie,faListUl } from '@fortawesome/free-solid-svg-icons';

import { SelectorGeneratorService } from './services';
import { ActionGeneratorService } from './services/action-generator.service';
import { SubscribedReportsComponent } from './subscribed-reports/subscribed-reports.component';
import { AccordionComponent, AccordionPanelComponent, DropdownComponent, LoaderComponent, LoaderService, MessageDialogComponent, PortfolioSelectorComponent, TabPanelComponent, TabsComponent, TabWithRoutingComponent, TopPanelComponent } from './widgets';
import { ChartTableToggleComponent } from './widgets/chart-table-toggle/chart-table-toggle.component';

@NgModule({
	imports: [
		FormsModule,
		GenericPipesModule,
		CommonModule,
		GenericDirectivesModule,
		CwpNgFrameworkModule,
		ReactiveFormsModule,
		MatTooltipModule,
		MatSliderModule,
		MatCardModule,
		MatSlideToggleModule,
		RouterModule,
		AnalyticsModule,
		AccessibilityModule,
		DzButtonModule,
		DzIconModule.withIcons(faListUl, faChartPie),
		DzTooltipModule,
		DomModule,
		DzProgressSpinnerModule
	],
	declarations: [
		AccordionComponent,
		AccordionPanelComponent,
		DropdownComponent,
		TopPanelComponent,
		LoaderComponent,
		SubscribedReportsComponent,
		PortfolioSelectorComponent,
		MessageDialogComponent,
		TabsComponent,
		TabPanelComponent,
		TabWithRoutingComponent,
		ChartTableToggleComponent
	],
	providers: [
		ActionGeneratorService,
		LoaderService,
		SelectorGeneratorService
	],
	exports: [
		AccordionComponent,
		AccordionPanelComponent,
		DropdownComponent,
		TopPanelComponent,
		CommonModule,
		LoaderComponent,
		SubscribedReportsComponent,
		PortfolioSelectorComponent,
		FormsModule,
		MessageDialogComponent,
		TabsComponent,
		TabPanelComponent,
		TabWithRoutingComponent,
		ChartTableToggleComponent,
		AccessibilityModule
	]
})
export class SharedModule {
}
